import { useEffect, useState, useCallback } from 'react';
import I18n from 'I18n';
import { useSearchText } from '../../hooks/viewFilters';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SearchBox({
  use
}) {
  const {
    searchText,
    setSearchText
  } = useSearchText();
  const [inputValue, setInputValue] = useState(searchText);

  // sync internal state with external state when external state changes
  useEffect(() => {
    setInputValue(searchText);
  }, [searchText]);
  const handleChange = useCallback(e => setInputValue(e.target.value), [setInputValue]);
  useEffect(() => {
    // if the search box is empty we can show results immediately
    // but we still use setTimeout to allow the box to rerender first
    const delayMs = inputValue ? 500 : 20;
    const id = setTimeout(() => setSearchText(inputValue), delayMs);
    return () => clearTimeout(id);
  }, [inputValue, setSearchText]);
  const placeholderText = I18n.text('crm-tasks-ui.overview.search');
  return /*#__PURE__*/_jsx(Tooltip, {
    title: placeholderText,
    placement: "right",
    children: /*#__PURE__*/_jsx(FormControl, {
      "aria-label": placeholderText,
      htmlFor: "tasks-search-box",
      children: /*#__PURE__*/_jsx(SearchInput, {
        type: "search",
        id: "tasks-search-box",
        value: inputValue,
        onChange: handleChange,
        "data-selenium-test": "tasks-search-box",
        placeholder: placeholderText,
        use: use,
        blockSize: "36px"
      })
    })
  });
}